"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.referenceMany = exports.referenceOne = void 0;
function referenceOne(source, ids, field) {
    if (Array.isArray(ids)) {
        // prettier-ignore
        return ids.map(function (id) { return referenceOne(source, id, field); }).filter(Boolean);
    }
    if (field !== undefined) {
        return source.find(function (x) { return x[field] === ids; }) || null;
    }
    return source.get(ids) || null;
}
exports.referenceOne = referenceOne;
/**
 * Given a single or list of ids and a collection with models,
 * returns the models that match `field`.
 * All matching models are returned and flattened.
 * For "one-to-one" type references, use `referenceOne`.
 *
 * @param {Collection<*>} source
 * @param {Array<string>} ids
 * @param {keyof T} field
 */
function referenceMany(source, ids, field) {
    if (Array.isArray(ids)) {
        var result = ids
            .map(function (id) { return referenceMany(source, id, field); })
            .filter(Boolean);
        return [].concat.apply([], result);
    }
    return source.filter(function (x) { return x[field] === ids; });
}
exports.referenceMany = referenceMany;
//# sourceMappingURL=normalization.js.map